<template>
    <VLayout>
        <VFlex>
            <VContainer grid-list-sm fluid>
                <VLayout wrap>
                    <VFlex v-for="(img, i) in arrayImagem" :key="i" xs4 d-flex child-flex>
                        <VCard flat tile class="d-flex" max-height="300" max-width="300">
                            <VImg :src="img.src" @click="ampliar(i)">
                                <template v-slot:placeholder>
                                    <VLayout fill-height align-center justify-center ma-0>
                                        <VProgressCircular indeterminate color="grey lighten-5"></VProgressCircular>
                                    </VLayout>
                                </template>
                            </VImg>
                        </VCard>
                    </VFlex>
                </VLayout>
            </VContainer>
        </VFlex>
        <PhotoSwipe :isOpen="photoswipe" :items="arrayImagem" :options="opcoesGaleria"
                    @close="photoswipe = false"></PhotoSwipe>
    </VLayout>
</template>
<script>
import {PhotoSwipe} from 'v-photoswipe';

    export default {
        components: {
            PhotoSwipe
        },
        data() {
            return {
                opcoesGaleria: {
                    shareEl: false,
                    index: 0
                },
                photoswipe: false
            }
        },
        props: {
            arquivos: {
                type: Array,
                default: () => ([])
            },
            arrayImagem: {
                type: Array,
                default: () => ([])
            }
        },
        methods: {
            ampliar(indice) {
                this.photoswipe = true;
                this.opcoesGaleria.index = indice;
            }
        }
    }
</script>

<style scoped>
</style>
